export default {
  computed: {
    fields() {
      return [
        {
          label: this.$t('report.fields.deliveryNumber'),
          key: 'number',
          isShow: true,
          isLocked: true,
        },
        {
          label: 'No. Shipment',
          key: 'shipment_number',
          isShow: true,
          isLocked: true,
        },
        {
          label: this.$t('report.fields.refOrder'),
          key: 'ref_order',
          isShow: true,
        },
        {
          label: this.$t('report.fields.deliveredDate'),
          key: 'delivered_on',
          isShow: true,
        },
        {
          label: this.$t('report.fields.customer'),
          key: 'shipped_customer.name',
          isShow: true,
        },
        {
          label: this.$t('report.fields.licenseNumber'),
          key: 'fleet_task.vehicle.license_plate',
          isShow: true,
        },
        {
          label: this.$t('report.fields.boxType'),
          key: 'box_type.name',
          isShow: true,
        },
        {
          label: this.$t('report.fields.driver'),
          key: 'fleet_task.driver_user.name',
          isShow: true,
        },
        {
          label: this.$t('report.fields.cost'),
          key: 'cost',
          isShow: true,
          tdClass: 'text-end'
        }
      ]
    } 
  }
}